<template>
  <router-view name="activitylog" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "ActivityLog",
};
</script>
